function loadMarkdownFiles() {
    const context = require.context('/public/docs', true, /\.md$/); // 加载 markdown 文件夹下的所有 .md 文件
    const files = context.keys().map((key) => ({
      path: key.replace(/^\./, ''), // 移除开头的点号
      name: key.split('/').pop().replace('.md', ''), // 提取文件名
    }));
    console.log('Loaded files:', files); // 添加日志查看可用文件
    return files;
}

export default loadMarkdownFiles;